export enum AuditFormStatusEnum {
  UNPUBLISHED = 'UNPUBLISHED',
  PUBLISHED = 'PUBLISHED',
  DEACTIVATED = 'DEACTIVATED'
}
